import { Container, Row, Col, Spacer } from '@cleartrip/bento/lib';
import { Table, TRow, TCol } from "../../../../src/gatsby-theme-docz/components/Table";
import * as React from 'react';
export default {
  Container,
  Row,
  Col,
  Spacer,
  Table,
  TRow,
  TCol,
  React
};